import {
  Link,
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
} from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { makeStyles } from '@material-ui/core';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import BuildIcon from '@material-ui/icons/Build';
import CategoryIcon from '@material-ui/icons/Category';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import ErrorIcon from '@material-ui/icons/Error';
import EventIcon from '@material-ui/icons/Event';
import ExtensionIcon from '@material-ui/icons/Extension';
import HomeIcon from '@material-ui/icons/Home';
import LayersIcon from '@material-ui/icons/Layers';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import TimelineIcon from '@material-ui/icons/Timeline';
import { PagerDutyIcon } from '@pagerduty/backstage-plugin';
import { CopilotIcon } from '../../components/Root/CopilotIcon';
import LogoIcon from '../../components/Root/LogoIcon';
import LogoMedium from '../../components/Root/LogoMedium';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: '100%',
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 8px',
    marginBottom: -14,
  },
  link: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginLeft: 0,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoMedium /> : <LogoIcon />}
      </Link>
    </div>
  );
};

const sidebarNavExtension = NavContentBlueprint.make({
  name: 'portal-navigation',
  params: {
    component: () => (
      <Sidebar>
        <SidebarLogo />
        <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
          <SidebarSearchModal />
        </SidebarGroup>
        <SidebarDivider />
        <SidebarGroup label="Menu" icon={<MenuIcon />}>
          <SidebarItem icon={HomeIcon} to="/" text="Home" />
          <SidebarItem icon={CategoryIcon} to="catalog" text="Catalog" />
          <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" />
          <SidebarItem icon={LibraryBooks} to="docs" text="Docs" />
          <SidebarItem icon={LayersIcon} to="explore" text="Explore" />
          <SidebarItem
            icon={AnnouncementIcon}
            to="announcements"
            text="Announcements"
          />
          <SidebarItem icon={TimelineIcon} to="newrelic" text="New Relic" />
          <SidebarItem icon={PagerDutyIcon} to="pagerduty" text="PagerDuty" />
          <SidebarItem icon={EventIcon} to="release-calendar" text="Releases" />
          <SidebarItem icon={CopilotIcon} to="copilot" text="Copilot" />
          <SidebarItem
            icon={CreateComponentIcon}
            to="create"
            text="Create..."
          />
          <SidebarDivider />
          <SidebarScrollWrapper />
        </SidebarGroup>
        <SidebarSpace />
        <SidebarDivider />
        <SidebarGroup label="Tools" icon={<ExtensionIcon />}>
          <SidebarItem
            icon={BuildIcon}
            to="entity-validation"
            text="Entity Validation"
          />
          <SidebarItem
            icon={ErrorIcon}
            to="catalog-unprocessed-entities"
            text="Unprocessed Entities"
          />
          <SidebarItem icon={BuildIcon} to="devtools" text="DevTools" />
          <SidebarItem
            icon={EmojiObjectsIcon}
            to="tech-insights"
            text="Scorecards"
          />
        </SidebarGroup>
        <SidebarSpace />
        <SidebarDivider />
        <SidebarGroup
          label="Settings"
          icon={<UserSettingsSignInAvatar />}
          to="/settings"
        >
          <NotificationsSidebarItem />
          <SidebarSettings />
        </SidebarGroup>
      </Sidebar>
    ),
  },
});

export default createFrontendModule({
  pluginId: 'app',
  extensions: [sidebarNavExtension],
});
